var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "day-legend" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c("img", {
        attrs: { src: require("@/assets/IC_Ausencia_Rechazada.svg") },
      }),
      _vm.withTitle
        ? _c("span", [
            _vm._v(_vm._s(_vm.$t("pages.permission.absences.rejected"))),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }